import Image from "next/image";
import { forwardRef } from "react";

interface SVGIconProps {
  src: string;
  alt?: string;
  className?: string;
  width?: number | string;
  height?: number | string;
  priority?: boolean;
}

export const SVGIcon = forwardRef<HTMLImageElement, SVGIconProps>(
  (
    { src, alt = "", className, width = "100%", height = "auto", priority },
    ref,
  ) => {
    return (
      <Image
        ref={ref}
        src={src}
        alt={alt}
        width={0}
        height={0}
        style={{ width, height }}
        className={className}
        priority={priority}
        aria-hidden
      />
    );
  },
);

SVGIcon.displayName = "SVGIcon";
